// src/services/billing.js
import { http } from './config/config-receituario'

export default {

  gerarCobranca: (token, idEmpresa, payloadExtra = {}) => {
    return http.post(
      `billing/empresa/${idEmpresa}`,
      payloadExtra,
      {
        headers: {
          Authorization: token,
        },
      }
    )
  },
}
